<div fxLayout="row" fxLayoutGap="50px" class="espaco" fxFlexFill>
    <label for="id" hidden>{{acao.id}}</label>
    <mat-form-field fxFlex= "11%" fxFlexOffset="20px">
        <input matInput name="dataPrevisaoInicio_{{pinDataPrevisaoInicio}}" 
                [matDatepicker]="dataPrevisaoInicio" 
                placeholder="Data Previsão de Início" 
                required
                (input)="onMascaraDataInput($event)"
                [(ngModel)]="acao.dataPrevisaoInicio"
                [disabled]="camposDesabilitados">
        <mat-datepicker-toggle matSuffix [for]="dataPrevisaoInicio"></mat-datepicker-toggle>
        <mat-datepicker #dataPrevisaoInicio></mat-datepicker>
    </mat-form-field>


    <mat-form-field fxFlex="10%">
        <mat-label>Local Execução</mat-label>
        <mat-select [(ngModel)]="acao.localExecucao" name="localExecucao_{{pinLocalExecucao}}" [disabled]="camposDesabilitados">
            <mat-option></mat-option>        
            <mat-option *ngFor="let m of local_execucao" [value]="m.flag">
            {{m.tipo}}
            </mat-option>
        </mat-select>
    </mat-form-field>        

    <mat-form-field fxFlex="70%" >
        <input [(ngModel)]=acao.descricao
               #descricao matInput  
               required
               name="descricao_{{pinDescricao}}" 
               placeholder="Descrição" 
               [disabled]="camposDesabilitados"/>
        <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>               
    </mat-form-field>

    <mat-form-field fxFlex="10%" fxFlexOffset="20px">
        <input matInput name="dataAprovaAcao_{{pinRandom}}" [matDatepicker]="dataAprovaAcao" placeholder="Data da Análise"
            [required]="acao.statusAnalise == 'A' || acao.statusAnalise === 'R'"
            (input)="onMascaraDataInput($event)" [(ngModel)]="acao.dataAprovaAcao"
            [disabled]="camposDesabilitados || (!perfilAcessoAnalise.insere && !perfilAcessoAnalise.altera)">
        <mat-datepicker-toggle matSuffix [for]="dataAprovaAcao"></mat-datepicker-toggle>
        <mat-datepicker #dataAprovaAcao></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="10%" fxFlexOffset="20px">
        <mat-label>Decisão da Análise</mat-label>
        <mat-select [(ngModel)]="acao.statusAnalise"
                    name="statusAnalise_{{pinRandom}}"
                    [disabled]="camposDesabilitados || (!perfilAcessoAnalise.insere && !perfilAcessoAnalise.altera)"
                    (ngModelChange)="onStatusAnaliseChange($event)">
            <mat-option></mat-option>
            <mat-option *ngFor="let m of statusAnaliseCombo" [value]="m.id">
                {{m.descricao}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
        <mat-label>Responsável por Análise</mat-label>
        <input #usuarioAnalise
               [disabled]="camposDesabilitados || (!perfilAcessoAnalise.insere && !perfilAcessoAnalise.altera)"
               matInput 
               maxlength="100" 
               [value]="acao?.funcionarioAprovaAcao?.pessoasFisica?.nome || ''"
               name="funcionarioAprovaAcao_{{pinRandom}}" 
               placeholder="Responsável Análise">
    </mat-form-field>

    <div>
        <button mat-icon-button 
                *ngIf="perfilAcesso.deleta && !camposDesabilitados" 
                (click)="deletarAcao()"
                style="padding-top: 15px; color: red;">
            <mat-icon>delete_forever</mat-icon>
        </button>                                
    </div>
    
</div>




